import { useEffect, useState } from "react";

/**
 * Sant när sajten körs som "app": i native-wrappern eller som installerad PWA
 * (standalone). Används för att ge appkänsla, t.ex. tema i menyn i stället för
 * i headern.
 */
export function useAppShell(): boolean {
  const [appLike, setAppLike] = useState(false);
  useEffect(() => {
    let alive = true;
    const standalone =
      window.matchMedia?.("(display-mode: standalone)").matches === true ||
      (window.navigator as unknown as { standalone?: boolean }).standalone === true;
    if (standalone) setAppLike(true);
    void import("@/app-bridge/core/wrapper").then((m) => {
      if (alive && m.isAppMode()) setAppLike(true);
    });
    return () => {
      alive = false;
    };
  }, []);
  return appLike;
}
